<h1 class="center" mat-dialog-title>Confirmar acción</h1>
<div class="center" mat-dialog-content>
  <p>{{ message }}</p>
</div>
<div class="center" :cr:cr mat-dialog-actions>
  <button mat-button (click)="onCancel()">Cancelar</button>
  <button mat-button [mat-dialog-close]="btn" cdkFocusInitial>Sí</button>
</div>
